"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useRecomputerGridSize = function (multiGridRef, columnCount) {
    (0, react_1.useEffect)(function () {
        if (multiGridRef)
            multiGridRef.current.recomputeGridSize();
    }, [multiGridRef, columnCount]);
    (0, react_1.useEffect)(function () {
        var resizeTimeout;
        function actualResizeHandler() {
            multiGridRef.current.recomputeGridSize();
        }
        function resizeThrottler() {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    actualResizeHandler();
                }, 66);
            }
        }
        window.addEventListener('resize', resizeThrottler, false);
        return function () {
            window.removeEventListener('resize', resizeThrottler);
        };
        // eslint-disable-next-line
    }, []);
};
exports.default = useRecomputerGridSize;
